import { RouteConfig } from 'vue-router';

import RouterView from '@/components/appLayout/Router.vue';
import { procedurePaymentPacksRoute } from './paymentPacks.route';
import { procedurePaymentsRoute } from './payments.route';

export const procedurePaymentContainerRoute: RouteConfig = {
  path: 'payment',
  component: RouterView,
  children: [procedurePaymentPacksRoute, procedurePaymentsRoute],
  meta: {
    breadcrumb: { title: 'Paczki płatności', name: 'procedurePaymentPacks' }
  }
};
